import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const buildingEntityAdapter: EntityAdapter = {
  entity: "building",
  adjustCreatePayload: (result, values, ctx) => {
    if (ctx.companySubjectId) {
      return { ...values, subject: ctx.companySubjectId };
    }
    if (!ctx.companyId) {
      return { ...values, impersonate_subject: ctx.selectedChildCompanySubjectId };
    }
    return result;
  },
  adjustUpdatePayload: (result, values, ctx) =>
    !ctx.companySubjectId && !ctx.companyId
      ? { ...values, impersonate_subject: ctx.selectedChildCompanySubjectId }
      : result,
  bodyCellSx: (building, baseSx) =>
    building.is_main_building ? { ...baseSx, fontWeight: "bold" } : baseSx,
};
